import React, { useCallback, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "../styles/formValidation.css";

export function useFormValidation(scope) {
  const [errors, setErrors] = useState([]);

  const hasError = useCallback((field) => errors.includes(field), [errors]);

  const clearError = useCallback((field) => {
    setErrors((current) => current.filter((item) => item !== field));
  }, []);

  const resetErrors = useCallback(() => setErrors([]), []);

  const validate = useCallback((fields) => {
    const nextErrors = Array.from(new Set((fields || []).filter(Boolean)));
    setErrors(nextErrors);

    if (nextErrors.length > 0) {
      window.requestAnimationFrame(() => {
        const target = document.querySelector(`[data-required-field="${scope}-${nextErrors[0]}"]`);
        const focusTarget = target?.matches?.("input, select, textarea, button")
          ? target
          : target?.querySelector?.("input, select, textarea, button");
        focusTarget?.focus?.({ preventScroll: true });
        target?.scrollIntoView?.({ behavior: "smooth", block: "center" });
      });
    }

    return nextErrors.length === 0;
  }, [scope]);

  const fieldClass = useCallback((field, base = "") => (
    `${base} ${errors.includes(field) ? "formFieldInvalid" : ""}`.trim()
  ), [errors]);

  return { errors, hasError, clearError, resetErrors, validate, fieldClass };
}

export default function FormValidationNotice({ errors = [], labels = {} }) {
  const { t } = useLanguage();
  if (!errors.length) return null;

  const fieldLabels = errors.map((field) => labels[field]).filter(Boolean);

  return (
    <div className="formValidationNotice" role="alert" aria-live="assertive">
      <span aria-hidden="true">!</span>
      <div>
        <b>{t("common.validation.title")}</b>
        <small>{t("common.validation.fillFields")} {fieldLabels.join(", ")}.</small>
      </div>
    </div>
  );
}
